import COLORS from '@utils/color';
import { TaskDisplayValues } from '@models/task.model';

export interface LegendItem {
  label: string;
  color: string;
  displayValue: TaskDisplayValues;
}

export const LEGEND_ITEMS: LegendItem[] = [
  {
    label: 'Complete',
    color: COLORS.lightBlue,
    displayValue: TaskDisplayValues.COMPLETE,
  },
  {
    label: 'Pending Client Approval',
    color: COLORS.darkGreen,
    displayValue: TaskDisplayValues.CLIENT_APPROVAL,
  },
  {
    label: 'Pending Internal Approval',
    color: COLORS.darkerGreen,
    displayValue: TaskDisplayValues.INTERNAL_APPROVAL,
  },
  {
    label: 'Inactive',
    color: COLORS.orange,
    displayValue: TaskDisplayValues.INACTIVE,
  },
  {
    label: 'Rejected',
    color: COLORS.error,
    displayValue: TaskDisplayValues.REJECTED,
  },
  {
    label: 'Canceled',
    color: COLORS.cancel,
    displayValue: TaskDisplayValues.CANCELED,
  },
  {
    label: 'Delegation Canceled',
    color: COLORS.violet,
    displayValue: TaskDisplayValues.DELEGATION_CANCELED,
  },
  {
    label: 'Upcoming',
    color: COLORS.upcoming,
    displayValue: TaskDisplayValues.UPCOMING,
  },
  {
    label: 'Behind Schedule',
    color: COLORS.error,
    displayValue: TaskDisplayValues.BEHIND_SCHEDULE,
  },
  {
    label: 'Unassigned',
    color: COLORS.orange,
    displayValue: TaskDisplayValues.UNASSIGNED,
  },
  {
    label: 'Assigned to Crew',
    color: COLORS.green,
    displayValue: TaskDisplayValues.ASSIGNED_TO_CREW,
  },
  {
    label: 'Assigned to Subcontractor',
    color: COLORS.darkBlue,
    displayValue: TaskDisplayValues.ASSIGNED_TO_SUBCONTRACTOR,
  },
  {
    label: 'In Negotiations',
    color: COLORS.negociations,
    displayValue: TaskDisplayValues.IN_NEGOTIATIONS,
  },
];
